export const SET_USER_NAVIGATION = 'SET_USER_NAVIGATION'

const getFeatureKeyByModuleCode = (moduleCode = '') => {
    const code = String(moduleCode || '').trim()
    if (!code) return ''
    const map = {
        marketing: 'feature_marketing',
        bonus: 'feature_bonus',
        catalog: 'feature_catalog',
        warehouse: 'feature_warehouse',
        telephony: 'feature_telephony',
        ext_api: 'feature_ext_api',
    }
    return map[code] || ''
}

const isBillingFeatureAllowed = (nav = {}, billingFeatures = {}) => {
    const moduleCode = String(nav?.moduleCode || '').trim()
    if (!moduleCode) return true
    const key = getFeatureKeyByModuleCode(moduleCode)
    if (!key) return true
    if (!billingFeatures || typeof billingFeatures !== 'object') return true
    if (!Object.prototype.hasOwnProperty.call(billingFeatures, key)) return true
    return !!billingFeatures[key]
}

export const getfilteredNavigations2 = (navList = [], role, typeAccount, accessPage, billingFeatures = {}, ownerAccess = false) => {
    return navList.reduce((array, nav) => {
        const children = Array.isArray(nav.children)
            ? getfilteredNavigations2(nav.children, role, typeAccount, accessPage, billingFeatures, ownerAccess)
            : [];

        const typeAllowed = Array.isArray(nav.typeShow) ? nav.typeShow.includes(typeAccount) : true;
        const roleAllowed = Array.isArray(nav.auth) ? nav.auth.includes(role) : true;
        const billingAllowed = isBillingFeatureAllowed(nav, billingFeatures);
        if (!typeAllowed || !roleAllowed || !billingAllowed) {
            return array;
        }

        const hasOwnAccessFlag = Boolean(nav?.accessPageName);
        const hasOwnAccess = hasOwnAccessFlag && (
            ownerAccess
            || (Array.isArray(accessPage) && (
                accessPage.includes(nav.accessPageName)
                || (String(nav.accessPageName).startsWith('WAREHOUSE_') && String(nav.accessPageName).endsWith('_VIEW') && accessPage.includes('WAREHOUSE'))
            ))
        );
        const hasVisibleChildren = children.length > 0;
        const hasPath = typeof nav?.path === 'string' && nav.path.length > 0;

        // Не пропускаем в меню "битые" узлы без path и без children:
        // они ломают NavLink (to=undefined).
        // Родителя показываем, если есть видимые дети, либо есть доступ к самому пункту и у него есть path.
        if (hasVisibleChildren || (hasOwnAccess && hasPath)) {
            const nextNav = { ...nav };
            if (hasVisibleChildren) {
                nextNav.children = children;
            } else {
                delete nextNav.children;
            }
            array.push(nextNav);
        }

        return array;
    }, []);
}

// export const getfilteredNavigations3 = (navList = [],child= false) => {
//     console.log('wtf',navList)
//     return navList.reduce((array, nav) => {
//
//         console.log('Да ИДИ ТЫ НАХУЙ');
//         if (nav.children ) {
//             nav.children = getfilteredNavigations3(nav.children,true)
//             // array.push(nav)
//
//             console.log('агагаа 222',nav,array)
//         } else {
//             console.log('агагаа',nav,array)
//             // array.push(nav)
//         }
//         if(child===true){
//             console.log('1111',nav)
//         }else {
//             console.log('3333',nav)
//         }
//
//
//                         array.push(nav)
//
//             console.log('Права доступа 33', nav);
//
//         // else {
//         //     console.log('Да ИДИ ТЫ НАХУЙ');
//         //     if (nav.children) {
//         //         nav.children = getfilteredNavigations2(nav.children, role, typeAccount)
//         //         array.push(nav)
//         //     } else {
//         //         array.push(nav)
//         //     }
//         // }
//         return array
//     }, [])
// }


const getfilteredNavigations = (navList = [], role) => {
    return navList.reduce((array, nav) => {
        if (nav.auth) {
            if (nav.auth.includes(role)) {
                array.push(nav)
            }
            // console.log('Права доступа ', nav.auth);
        } else {
            if (nav.children) {
                nav.children = getfilteredNavigations(nav.children, role)
                array.push(nav)
            } else {
                array.push(nav)
            }
        }
        return array
    }, [])
}

export const getNavigationByUser = (user)=> {
    return (dispatch, getState) => {
        let { navigations = [] } = getState();

        let filteredNavigations = getfilteredNavigations(navigations, user.role);

            console.log('Функция используется',filteredNavigations);

        // dispatch({
        //     type: SET_USER_NAVIGATION,
        //     payload: [...filteredNavigations],
        // })
    }
}
